import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M3.00124 4.53999C2.61124 4.14999 2.61124 3.51999 3.00124 3.12999C3.18807 2.94274 3.44172 2.83751 3.70624 2.83751C3.97076 2.83751 4.22441 2.94274 4.41124 3.12999L20.7312 19.46C21.1212 19.85 21.1212 20.48 20.7312 20.87C20.3412 21.26 19.7112 21.26 19.3212 20.87L16.8412 18.39C16.6812 18.49 16.5012 18.57 16.2912 18.57H4.29124C3.74124 18.57 3.29124 18.12 3.29124 17.57V7.56999C3.29124 7.01999 3.74124 6.56999 4.29124 6.56999H5.02124L3.00124 4.53999ZM21.2912 9.47999V14.77C21.2912 15.66 20.2112 16.11 19.5912 15.48L10.6812 6.56999H16.2912C16.8412 6.56999 17.2912 7.01999 17.2912 7.56999V11.07L19.5812 8.76999C20.2112 8.13999 21.2912 8.58999 21.2912 9.47999Z";

export default function VideocamOffIcon(props: IconProps) {
  return (
    <SVGIcon path={path} fillRule="evenodd" clipRule="evenodd" {...props} />
  );
}
